<template>
  <Popover ref="poPopover" :showHeader="true" headerTitle="Glass On Order">
    <div class="glass-size-info-popover-content">
      <Spinner v-if="loading" />
      <StaticDataTable class="static-table-list" v-if="!loading && glassSize" variant="table-sm">
        <template v-slot:header>
          <tr>
            <th>Purchase Order</th>
            <th>Supplier</th>
            <th>Status</th>
            <th>Advised Receiving</th>
            <th>On Order</th>
          </tr>
        </template>
        <template v-slot:body>
          <tr v-for="purchaseOrder in glassSize.purchaseOrders" :key="purchaseOrder.id">
            <td class="font-weight-bold">
              <LinkPurchaseOrder :id="purchaseOrder.id" :name="purchaseOrder.sequenceNumber ? purchaseOrder.sequenceNumber : 'Purchase Order'" />
            </td>
            <td>
              <LinkContact :id="purchaseOrder.contact.id" :name="purchaseOrder.contact.name" />
            </td>
            <td>
              <LabelBadge :labelClass="`label-po-status-${purchaseOrder.status}`">{{purchaseOrder.status | formatLookupName(PurchaseOrderStatusTypeLookup)}}</LabelBadge>
            </td>
            <td>
              <span v-if="purchaseOrder.dateAdvised">{{purchaseOrder.dateAdvised | formatDate}}</span>
              <span v-else>Unknown</span>
            </td>
            <td>{{purchaseOrder.onOrder}}</td>
          </tr>
          <tr class="static-datatable-row-nostripe border-top table-totals-row" v-if="glassSize.purchaseOrders.length > 0">
            <td colspan="4" class="text-right">Totals:</td>
            <td>{{totalSheetsOnOrder}}</td>
          </tr>
        </template>
        <template v-slot:empty v-if="!glassSize.purchaseOrders || glassSize.purchaseOrders.length == 0">No stock currently on order</template>
      </StaticDataTable>
      
    </div>
  </Popover>
</template>

<style scoped>
.glass-size-info-popover-content {
  padding: 6px;
  min-width: 400px;
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>

<script>
import Popover from '@/components/popover.vue'
import StaticDataTable from '@/components/table/staticDataTable.vue'

import { PurchaseOrderStatusTypeLookup } from '@/store/types'

export default {
  name: 'GlassSizePOPopover',
  components: {
    Popover,
    StaticDataTable
  },
  data() {
    return {
      loading: false,
      stockId: null,
      glassSizeId: null,
      glassSize: null
    }
  },
  computed: {
    totalSheetsOnOrder() {
      if(this.glassSize && this.glassSize.purchaseOrders) {
        return this.glassSize.purchaseOrders.reduce((sheetCount, order) => sheetCount + order.onOrder, 0)
      }
      return 0
    }
  },
  created() {
    this.PurchaseOrderStatusTypeLookup = PurchaseOrderStatusTypeLookup
  },
  mounted() {
    
  },
  methods: {
    requestData() {
      this.loading = true
      this.$apiService.inventoryService.getGlassSize(this.stockId, this.glassSizeId)
      .then(response => {
        this.glassSize = response.data
      })
      .finally(() => {
        this.loading = false
      })
    },
    displayFromElement(element, stockId, glassSizeId) {
      this.stockId = stockId
      this.glassSizeId = glassSizeId
      this.glassSize = null
      this.requestData()

      this.$refs.poPopover.displayFromElement(element)
    }
  }

}
</script>